import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=1973e57d&scoped=true&lang=pug&"
import script from "./radio-group.vue?vue&type=script&lang=js&"
export * from "./radio-group.vue?vue&type=script&lang=js&"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=1973e57d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1973e57d",
  null
  
)

/* custom blocks */
import block0 from "~/lang/formFields?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230609154748%2Fcomponents%2Fwidgets%2Fforms%2Fradio-group.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports